import PropTypes from "prop-types";
/* eslint-disable */
// material-ui
import {
  Box,
  Card,
  Grid,
  Typography,
  Button,
  IconButton,
  Divider,
  Paper,
  CircularProgress,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Skeleton,
} from "@mui/material";

// project imports
import MainCard from "./cards/MainCard";
import { gridSpacing } from "../store/constant";
import AdBanner from "./advertisement/AdBanner";

import React, { useState, useEffect } from "react";
import axios from "../Axios/axiosConfig";
import CustomSnackbar from "./snackbar/CustomSnackbar";
import AttachmentIcon from "@mui/icons-material/Attachment";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/GetApp";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import NewReleasesIcon from "@mui/icons-material/NewReleases";
import LinkIcon from "@mui/icons-material/Link";
import EditNoteIcon from "@mui/icons-material/EditNote";
import ArticleIcon from "@mui/icons-material/Article";
import useMediaQuery from "@mui/material/useMediaQuery";
import "react-quill/dist/quill.snow.css";
import LinearProgress from "@mui/material/LinearProgress";

// Lazy load heavy components and editors
const BasicModal = React.lazy(() => import("./TextModel"));
const GetTextModal = React.lazy(() => import("./getTextModel"));
const FileUploadModal = React.lazy(() => import("./FileuploadModel"));
const ReactQuill = React.lazy(() => import("react-quill"));
const QRCodeGenerator = React.lazy(() => import("./QRCodeGenerator"));

// ===============================|| COLOR BOX ||=============================== //

const ColorBox = ({ bgcolor, title, data, dark }) => (
  <>
    <Card sx={{ mb: 3 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          py: 4.5,
          bgcolor,
          color: dark ? "grey.800" : "#ffffff",
        }}
      >
        {title && (
          <Typography variant="subtitle1" color="inherit">
            {title}
          </Typography>
        )}
        {!title && <Box sx={{ p: 1.15 }} />}
      </Box>
    </Card>
  </>
);

ColorBox.propTypes = {
  bgcolor: PropTypes.string,
  title: PropTypes.string,
  data: PropTypes.object.isRequired,
  dark: PropTypes.bool,
};

// ===============================|| UI COLOR ||=============================== //

const PasteText = () => {
  const isMobile = useMediaQuery("(max-width: 600px)");
  const [error, setError] = React.useState("");
  const [showSnackbar, setShowSnackbar] = React.useState(false);
  const [snackbarType, setSnackbarType] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [openFileUpload, setOpenFileUpload] = React.useState(false);
  const [getTextOpen, setgetTextOpen] = React.useState(false);
  const [serverImages, setServerImages] = React.useState([]);
  const [editorHtml, setEditorHtml] = useState("");
  const [loading, setLoading] = React.useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  //file upload feature
  const [files, setFiles] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [publishedCode, setPublishedCode] = useState('');
  const [publishedAt, setPublishedAt] = useState(null);
  const [keepAliveHours, setKeepAliveHours] = useState(12);
  const [isOneTimeRead, setIsOneTimeRead] = useState(false);
  const [countdown, setCountdown] = useState('');
  const [retrievedOneTimeRead, setRetrievedOneTimeRead] = useState(false);
  const [copied, setCopied] = useState(false);
  const [copiedLink, setCopiedLink] = useState(false);
  const [whatsNewOpen, setWhatsNewOpen] = useState(false);
  const [hasNewUpdates, setHasNewUpdates] = useState(false);

  useEffect(() => {
    // Check if user has already viewed the latest updates
    const viewed = localStorage.getItem("viewed_whats_new_v2");
    if (!viewed) {
      setHasNewUpdates(true);
    }
  }, []);

  // Countdown timer for note expiry
  useEffect(() => {
    if (!publishedAt) return;
    const tick = () => {
      const expiryMs = publishedAt + keepAliveHours * 60 * 60 * 1000;
      const remaining = expiryMs - Date.now();
      if (remaining <= 0) {
        setCountdown('Expired');
        return;
      }
      const h = Math.floor(remaining / 3600000);
      const m = Math.floor((remaining % 3600000) / 60000);
      const s = Math.floor((remaining % 60000) / 1000);
      setCountdown(`${h}h ${m}m ${s}s`);
    };
    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, [publishedAt, keepAliveHours]);

  const handleOpenWhatsNew = () => {
    setWhatsNewOpen(true);
    setHasNewUpdates(false);
    localStorage.setItem("viewed_whats_new_v2", "true");
  };

  const handleCopyCode = () => {
    if (publishedCode) {
      navigator.clipboard.writeText(publishedCode);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const handleCopyLink = () => {
    if (publishedCode) {
      navigator.clipboard.writeText(`https://justpasteit.in/get/${publishedCode}`);
      setCopiedLink(true);
      setTimeout(() => setCopiedLink(false), 2000);
    }
  };

  // Updated callback: receives code + keepAliveTime + oneTimeRead from TextModel
  const handleSetPublishedCode = (code, hours, oneTimeRead) => {
    setPublishedCode(code);
    setPublishedAt(Date.now());
    setKeepAliveHours(hours || 12);
    setIsOneTimeRead(!!oneTimeRead);
    
    // Scroll to top to show the generated code, wrapped in setTimeout to allow modal to close first
    setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, 100);
  };

  // Load ad script
  useEffect(() => {
    const script = document.createElement('script');
    script.async = true;
    script.setAttribute('data-cfasync', 'false');
    script.src = '//pl27807086.revenuecpmgate.com/5ba1bdc6fb69a292f91cc431ba7e3325/invoke.js';
    document.body.appendChild(script);
    
    return () => {
      if (script.parentNode) {
        document.body.removeChild(script);
      }
    };
  }, []);

  const handlePostText = () => {
    setShowSnackbar(false);
    setOpen(!open);
  };
  const toggleGetTextModel = () => {
    setShowSnackbar(false);
    setgetTextOpen(!getTextOpen);
    setError("");
  };
  const fetchData = (codeText) => {
    // Display loading spinner while the request is in progress
    setLoading(true);

    axios
      .get(`/texts/${codeText}`)
      .then((response) => {
        let editorContent = JSON.parse(response.data.content);

        if (
          response.data &&
          response.data.files &&
          response.data.files.length > 0
        ) {
          setServerImages([...response.data.files]);
        }
        setFiles([]); // Reset the old upload to blank
        setEditorHtml(editorContent);
        setRetrievedOneTimeRead(!!response.data.oneTimeRead);
        toggleGetTextModel();
        // Show snack bar
        setSnackbarType("fetchSuccess");
        toggleSnackBar();

        // Hide loading spinner after successful response
        setLoading(false);
      })
      .catch((error) => {
        if (error.response?.status == 404) {
          setError("No text found with the given code");
        } else {
          toggleGetTextModel();
          // Show snack bar
          setSnackbarType("failed");
          toggleSnackBar();
        }
        // Hide loading spinner after error
        setLoading(false);

        // Handle the error or display it as needed
        console.error(error);
      });
  };

  const getTextData = (codeText) => {};

  const toggleSnackBar = () => {
    setShowSnackbar(!showSnackbar);
  };

  const toggleFileUploadModel = () => {
    setOpenFileUpload(!openFileUpload);
  };

  const handleFileUpload = (uploadedFiles) => {
    // Process the uploaded files here, e.g., send them to the server
    if (uploadedFiles.length > 0) {
      // Generate image previews for valid image files
      const imageFiles = uploadedFiles.filter((file) =>
        file.type.startsWith("image/")
      );
      const newImagePreviews = [...imagePreviews];
      imageFiles.forEach((imageFile) => {
        const imageUrl = URL.createObjectURL(imageFile);
        newImagePreviews.push({ file: imageFile, previewUrl: imageUrl });
      });
      setImagePreviews(newImagePreviews);
      setFiles((prevFiles) => [...prevFiles, ...uploadedFiles]);
    }
  };

  const handleDeleteFile = (fileToDelete) => {
    // Revoke data URIs for image previews
    if (fileToDelete.type.startsWith("image/")) {
      const updatedImagePreviews = imagePreviews.filter(
        (preview) => preview.file !== fileToDelete
      );
      setImagePreviews(updatedImagePreviews);
    }

    const updatedFiles = files.filter((file) => file !== fileToDelete);
    setFiles(updatedFiles);
  };

  function handleDownloadFile(filename) {
    // Replace 'http://localhost:8994' with your actual server URL
    const fileURL = `https://justpasteit.in/uploads/${filename}`;

    // Fetch the file and trigger the download
    fetch(fileURL)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = filename.split("-")[1] || filename;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.error("Error downloading file:", error);
      });
  }

  const handleChange = (content) => {
    // Regular expression to match the specific URL
    const forbiddenUrlPattern = /https:\/\/cdn\.discordapp\.com/g;
    
    // Check if the content contains the forbidden URL
    if (!forbiddenUrlPattern.test(content)) {
      setEditorHtml(content)
    } else {
      alert("Links or text from cdn.discordapp.com are not allowed. Your IP address and email have been reported");
      setEditorHtml("");
    }
  };

  const formats = [
    "header",
    "font",
    "size",
    "color",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "video",
    "align",
  ];
  const modules = {
    toolbar: [
      ["bold", "italic", "underline", "strike"], // toggled buttons

      [{ list: "ordered" }, { list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }], // outdent/indent

      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ font: [] }, { color: [] }],
      [{ align: [] }, "link", "image"],
    ],
    clipboard: {
      matchVisual: false, // Disable Quill's default pasting
    },
    history: {
      delay: 2000,
      maxStack: 500,
      userOnly: true,
    },
  };

  let quill;
  const quillRef = (ref) => {
    if (ref) {
      quill = ref.getEditor();

      // Define the custom image handler
      quill.getModule("toolbar").addHandler("image", () => {
        // Trigger the file input to open when the custom image button is clicked
        const input = document.createElement("input");
        input.setAttribute("type", "file");
        input.setAttribute("accept", "image/*");
        input.addEventListener("change", () => {
          const file = input.files[0];
          if (file) {
            // Handle the image upload
            handleImageUpload(file, quill);
          }
        });
        input.click();
      });
    }
  };

  // Implement the custom image handler function
  // Implement the custom image handler function
  const handleImageUpload = (image, quill) => {
    //on Image upload Loading
    const range = quill.getSelection();
    let imageUrl;
    // setLoading(true); // Show loading spinner
    // Once you have the image URL, insert it into the editor
    const formData = new FormData();
    formData.append("file", image);

    // Send the image to your server and get the image URL
    axios
      .post("/texts/upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data", // Set the content type to FormData
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setUploadProgress(percentCompleted);
        },
      })
      .then((response) => {
        if (response.status === 201) {
          return response.data;
        } else {
          console.log("Image upload failed.");
        }
      })
      .then((data) => {
        console.log("range", range);
        imageUrl = data.fileName;
        quill.insertEmbed(
          range.index,
          "image",
          `https://justpasteit.in/uploads/${imageUrl}`
        );
        const updatedEditorHtml = quill.root.innerHTML;
        setEditorHtml(updatedEditorHtml);
        console.log("quill after image", quill);
      })
      .catch((error) => {
        console.error("Image upload error:", error);
      })
      .finally(() => {
        setUploadProgress(0); // Hide loading spinner
      });
  };

  return (
    <>
      {loading ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
          }}
        >
          <CircularProgress color="secondary" size={64} />
        </div>
      ) : (
        <MainCard content={true}>
          <CustomSnackbar
            showSnackbar={showSnackbar}
            snackbarType={snackbarType}
          />

          <React.Suspense fallback={null}>
            <BasicModal
              isOpen={open}
              toggleSnackBar={toggleSnackBar}
              setSnackbarType={setSnackbarType}
              editorState={editorHtml} //old code of editoreState
              handlePostText={handlePostText}
              files={files}
              setUploadProgress={setUploadProgress}
              setPublishedCode={handleSetPublishedCode}
            />
            <GetTextModal
              isMobile={isMobile}
              isOpen={getTextOpen}
              toggleGetTextModel={toggleGetTextModel}
              fetchData={fetchData}
              error={error}
            />
            <FileUploadModal
              handleFileUpload={handleFileUpload}
              files={files}
              isOpen={openFileUpload}
              toggleFileUploadModel={toggleFileUploadModel}
            />
          </React.Suspense>
          <Grid
            container
            spacing={gridSpacing}
            alignItems="center"
            justifyContent="space-between"
          >
            <Grid item sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography
                variant="h1"
                style={{ fontSize: "1rem", fontWeight: 500, margin: 0 }}
              >
                Just Paste It
              </Typography>
              <Tooltip 
                title={
                  <Box sx={{ p: 0.5 }}>
                    <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 0.5, color: '#fff' }}>Latest Updates:</Typography>
                    <Typography variant="caption" display="block">• No CAPTCHAs for private notes</Typography>
                    <Typography variant="caption" display="block">• Auto-generated secured room codes</Typography>
                    <Typography variant="caption" display="block">• One-click clipboard copy for codes</Typography>
                  </Box>
                }
                arrow
                placement="bottom-start"
              >
                <Chip
                  icon={<AutoAwesomeIcon sx={{ fontSize: '0.9rem !important' }} />}
                  label="What's New"
                  size="small"
                  onClick={handleOpenWhatsNew}
                  color={hasNewUpdates ? "secondary" : "default"}
                  sx={{ 
                    height: '20px', 
                    fontSize: '0.75rem',
                    fontWeight: 600,
                    cursor: 'pointer',
                    '& .MuiChip-label': { paddingLeft: '4px', paddingRight: '6px' },
                    ...(hasNewUpdates && {
                      animation: 'pulse 2s infinite',
                      '@keyframes pulse': {
                        '0%': { boxShadow: '0 0 0 0 rgba(225, 41, 126, 0.4)' },
                        '70%': { boxShadow: '0 0 0 6px rgba(225, 41, 126, 0)' },
                        '100%': { boxShadow: '0 0 0 0 rgba(225, 41, 126, 0)' }
                      }
                    })
                  }}
                />
              </Tooltip>
              <Box 
                sx={{ 
                  display: { xs: 'none', md: 'flex' }, 
                  alignItems: 'center', 
                  gap: 1.5, 
                  ml: 2,
                  bgcolor: 'background.neutral',
                  border: '1px solid',
                  borderColor: 'divider',
                  px: 1.5,
                  py: 0.5,
                  borderRadius: '16px'
                }}
              >
                <Typography 
                  variant="caption" 
                  sx={{ 
                    color: 'text.secondary', 
                    fontWeight: 600, 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: 0.5,
                    fontSize: '0.725rem'
                  }}
                >
                  ⚡ No CAPTCHAs for notes
                </Typography>
                <Divider orientation="vertical" flexItem sx={{ height: 12, my: 'auto' }} />
                <Typography 
                  variant="caption" 
                  sx={{ 
                    color: 'text.secondary', 
                    fontWeight: 600, 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: 0.5,
                    fontSize: '0.725rem'
                  }}
                >
                  🎲 Auto-codes
                </Typography>
                <Divider orientation="vertical" flexItem sx={{ height: 12, my: 'auto' }} />
                <Typography 
                  variant="caption" 
                  sx={{ 
                    color: 'text.secondary', 
                    fontWeight: 600, 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: 0.5,
                    fontSize: '0.725rem'
                  }}
                >
                  📋 One-click copy
                </Typography>
                <Divider orientation="vertical" flexItem sx={{ height: 12, my: 'auto' }} />
                <Typography 
                  variant="caption" 
                  sx={{ 
                    color: 'text.secondary', 
                    fontWeight: 600, 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: 0.5,
                    fontSize: '0.725rem'
                  }}
                >
                  🔥 One-Time Read
                </Typography>
              </Box>
            </Grid>
            <Grid item>
              {publishedCode && (
                <Box sx={{ textAlign: 'center', mb: 1 }}>
                  <Typography
                    variant="body2"
                    style={{ fontSize: "0.875rem", color: "#666", marginBottom: "4px" }}
                  >
                    Your Secured Room Code:
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, mb: 1 }}>
                    <Typography
                      variant="h6"
                      style={{ 
                        fontSize: "1rem", 
                        fontWeight: 600, 
                        color: "#1976d2",
                        padding: "4px 8px",
                        backgroundColor: "#f5f5f5",
                        borderRadius: "4px",
                        border: "1px solid #e0e0e0",
                        margin: 0
                      }}
                    >
                      {publishedCode}
                    </Typography>
                    <Tooltip title="Copy code">
                      <IconButton size="small" onClick={handleCopyCode} color="primary" aria-label="Copy secured room code to clipboard">
                        {copied ? <CheckIcon fontSize="small" /> : <ContentCopyIcon fontSize="small" />}
                      </IconButton>
                    </Tooltip>
                    <Tooltip title={copiedLink ? "Link copied!" : "Copy shareable link"}>
                      <IconButton size="small" onClick={handleCopyLink} color={copiedLink ? "success" : "default"} aria-label="Copy shareable link to clipboard">
                        {copiedLink ? <CheckIcon fontSize="small" /> : <LinkIcon fontSize="small" />}
                      </IconButton>
                    </Tooltip>
                  </Box>
                  {isOneTimeRead ? (
                    <Typography
                      variant="caption"
                      sx={{
                        fontSize: '0.85rem',
                        color: '#e53935',
                        fontWeight: 600,
                        display: 'block',
                        mb: 0.5
                      }}
                    >
                      🔥 One-Time Read — deleted after retrieval
                    </Typography>
                  ) : (
                    countdown && (
                      <Typography
                        variant="caption"
                        sx={{
                          fontSize: '0.72rem',
                          color: countdown === 'Expired' ? '#e53935' : '#f57c00',
                          fontWeight: 600,
                          display: 'block',
                          mb: 0.5
                        }}
                      >
                        ⏱ Expires in: {countdown}
                      </Typography>
                    )
                  )}
                  <Typography
                    variant="caption"
                    style={{ fontSize: "0.75rem", color: "#888", display: "block", marginBottom: "8px" }}
                  >
                    Use this code to retrieve your text
                  </Typography>
                </Box>
              )}
              {publishedCode && (
                <React.Suspense fallback={
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1, mt: 2, p: 2, border: '1px solid #e0e0e0', borderRadius: '8px', backgroundColor: '#fafafa', width: '100%', maxWidth: isMobile ? 150 : 200 }}>
                    <Skeleton variant="text" width="80%" height={20} />
                    <Skeleton variant="rectangular" width="100%" height={isMobile ? 150 : 200} sx={{ borderRadius: '4px' }} />
                  </Box>
                }>
                  <QRCodeGenerator 
                    text={publishedCode} 
                    size={isMobile ? 150 : 200} 
                  />
                </React.Suspense>
              )}
              <Button
                disableElevation
                fullWidth
                size={isMobile ? "small" : "large"}
                type="submit"
                variant="contained"
                color="secondary"
                onClick={toggleGetTextModel}
              >
                Retrieve Notes
              </Button>
            </Grid>
            <Grid item xs={12}>
              {/* One-Time Read warning banner */}
              {retrievedOneTimeRead && (
                <Box
                  sx={{
                    mb: 1,
                    p: 1.5,
                    borderRadius: 2,
                    backgroundColor: '#fff3e0',
                    border: '1px solid #ff9800',
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: 1,
                  }}
                >
                  <span style={{ fontSize: '1.1rem', lineHeight: 1.4 }}>🔥</span>
                  <Box>
                    <Typography variant="body2" sx={{ fontWeight: 700, color: '#e65100' }}>
                      One-Time Read Note
                    </Typography>
                    <Typography variant="caption" sx={{ color: '#bf360c' }}>
                      This note has been permanently deleted from the server. You are viewing a local copy — once you close or refresh this page, it will be gone forever.
                    </Typography>
                  </Box>
                </Box>
              )}
              <Grid item mb={1} xs={12} sm={12} md={12} lg={12}>
                <Paper
                  m={1}
                  data-text-editor="name"
                  style={{
                    height: "300px",
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    overflow: "auto",
                  }}
                >
                  <React.Suspense fallback={
                    <Box sx={{ width: "100%", height: "100%", minHeight: "200px", display: "flex", flexDirection: "column", p: 2, gap: 1.5 }}>
                      {/* Editor Toolbar Skeleton */}
                      <Box sx={{ display: "flex", gap: 1, mb: 1, borderBottom: "1px solid", borderColor: "divider", pb: 1, flexWrap: 'wrap' }}>
                        <Skeleton variant="rectangular" width={40} height={24} />
                        <Skeleton variant="rectangular" width={40} height={24} />
                        <Skeleton variant="rectangular" width={60} height={24} />
                        <Skeleton variant="rectangular" width={30} height={24} />
                        <Skeleton variant="rectangular" width={30} height={24} />
                        <Skeleton variant="rectangular" width={30} height={24} />
                      </Box>
                      {/* Editor Body Text Lines */}
                      <Skeleton variant="text" width="60%" height={24} />
                      <Skeleton variant="text" width="90%" height={24} />
                      <Skeleton variant="text" width="80%" height={24} />
                      <Skeleton variant="text" width="40%" height={24} />
                    </Box>
                  }>
                    <ReactQuill
                      ref={quillRef}
                      style={{
                        height: "210px",
                        minHeight: "200px",
                        maxHeight: isMobile ? "380px" : "330px",
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                      }}
                      theme="snow"
                      value={editorHtml}
                      onChange={handleChange}
                      modules={modules}
                      formats={formats}
                      placeholder="Write something..."
                      bounds={`[data-text-editor="name"]`}
                    />
                  </React.Suspense>
                </Paper>
              </Grid>
              
    

              {/* Advertisement Banner - Divided into two sections */}
              <Grid container spacing={1} sx={{ mt: 0, mb: 1 }}>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Box sx={{ position: 'relative' }}>
                    <AdBanner 
                      type="content" 
                      isPlaceholder={true}
                      onContactClick={() => window.location.href = '/contact-us'}
                    />
                    <Typography
                      variant="h4"
                      sx={{
                        position: 'absolute',
                        top: { xs: '8px', sm: '50%' },
                        right: '8px',
                        transform: { xs: 'none', sm: 'translateY(-50%)' },
                        color: '#FF6B35',
                        fontWeight: 'bold',
                        fontSize: { xs: '0.9rem', sm: '1.3rem', md: '1.6rem' },
                        textShadow: '1px 1px 2px rgba(0,0,0,0.3)',
                        backgroundColor: 'rgba(255, 255, 255, 0.95)',
                        padding: { xs: '2px 6px', sm: '4px 8px' },
                        borderRadius: { xs: '4px', sm: '8px' },
                        border: { xs: '1px solid #FF6B35', sm: '2px solid #FF6B35' },
                        zIndex: 10,
                        lineHeight: 1.2
                      }}
                    >
                      Only $1/month!
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Box sx={{ position: 'relative' }}>
                    <AdBanner 
                      type="content" 
                      isPlaceholder={true}
                      onContactClick={() => window.location.href = '/contact-us'}
                    />
                    <Typography
                      variant="h4"
                      sx={{
                        position: 'absolute',
                        top: { xs: '8px', sm: '50%' },
                        right: '8px',
                        transform: { xs: 'none', sm: 'translateY(-50%)' },
                        color: '#FF6B35',
                        fontWeight: 'bold',
                        fontSize: { xs: '0.9rem', sm: '1.3rem', md: '1.6rem' },
                        textShadow: '1px 1px 2px rgba(0,0,0,0.3)',
                        backgroundColor: 'rgba(255, 255, 255, 0.95)',
                        padding: { xs: '2px 6px', sm: '4px 8px' },
                        borderRadius: { xs: '4px', sm: '8px' },
                        border: { xs: '1px solid #FF6B35', sm: '2px solid #FF6B35' },
                        zIndex: 10,
                        lineHeight: 1.2
                      }}
                    >
                      Only $1/month!
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
              
                        {/* Ad Script Container */}
              <Grid item xs={12}>
                <Box sx={{ textAlign: 'center', my: 2 }}>
                  <div id="container-5ba1bdc6fb69a292f91cc431ba7e3325" style={{ minHeight: "90px" }}></div>
                </Box>
              </Grid>
              
              {uploadProgress > 0 && (
                <LinearProgress variant="determinate" value={uploadProgress} />
              )}
              <Grid container spacing={gridSpacing} direction="row">
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  {serverImages.length > 0 ? (
                    <Grid container spacing={gridSpacing}>
                      {serverImages.map((file, index) => {
                        return (
                          <Grid
                            item
                            xs={12}
                            sm={6}
                            md={4}
                            lg={3}
                            key={file.filename}
                          >
                            <div
                              style={{
                                width: "100%",
                                height: "75%", // Adjust the height
                                padding: "8px",
                                border: "1px solid #e0e0e0",
                                borderRadius: "8px",
                                boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.1)",
                                position: "relative",
                              }}
                            >
                              <IconButton
                                onClick={() =>
                                  handleDownloadFile(file.generatedFilename)
                                }
                                style={{
                                  position: "absolute",
                                  top: "4px",
                                  right: "4px",
                                  zIndex: 1,
                                  backgroundColor: "#fff",
                                }}
                                aria-label="Download uploaded file"
                              >
                                <DownloadIcon />
                              </IconButton>

                              <Grid
                                container
                                alignItems="center"
                                spacing={gridSpacing}
                                style={{ width: "100%", height: "100%" }}
                              >
                                <Grid
                                  item
                                  xs={12}
                                  sm={6}
                                  md={6}
                                  style={{ textAlign: "center" }}
                                >
                                  {file.type.startsWith("image/") ? (
                                    <Box
                                      component="img"
                                      sx={{
                                        maxWidth: "100%",
                                        maxHeight: "100px",
                                        display: "block",
                                        margin: "0 auto",
                                      }}
                                      onLoad={() => {
                                        URL.revokeObjectURL(
                                          imagePreviews.find(
                                            (preview) => preview.file === file
                                          )?.previewUrl
                                        );
                                      }}
                                      alt="just paste it images"
                                      src={`https://justpasteit.in/uploads/${file.generatedFilename}`}
                                    />
                                  ) : (
                                    <AttachmentIcon
                                      sx={{
                                        fontSize: "48px",
                                        color: "#757575",
                                        display: "block",
                                        margin: "0 auto",
                                      }}
                                    />
                                  )}
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  sm={6}
                                  md={6}
                                  style={{ textAlign: "center" }}
                                >
                                  <Typography
                                    variant="body2"
                                    align="center" // Align center for mobile view
                                    style={{
                                      whiteSpace: "nowrap",
                                      textOverflow: "ellipsis",
                                      overflow: "hidden",
                                      maxWidth: "100%",
                                    }}
                                  >
                                    {file.filename}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </div>
                            <Divider sx={{ my: gridSpacing }} />
                          </Grid>
                        );
                      })}
                    </Grid>
                  ) : (
                    <Grid container spacing={gridSpacing}>
                      {files.map((file, index) => (
                        <Grid item xs={12} sm={6} md={4} lg={3} key={file.name}>
                          <div
                            style={{
                              width: "100%",
                              height: "75%",
                              padding: "8px",
                              border: "1px solid #e0e0e0",
                              borderRadius: "8px",
                              boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.1)",
                              position: "relative", // Make the container relative for positioning the close icon
                            }}
                          >
                            {/* Close Icon for removing the card */}
                            <IconButton
                              onClick={() => handleDeleteFile(file)}
                              style={{
                                position: "absolute",
                                top: "4px", // Adjust the top position
                                right: "4px", // Adjust the right position
                                zIndex: 1, // Ensure the icon is above other content
                                backgroundColor: "#fff", // Background color for the icon
                              }}
                              aria-label="Remove uploaded file"
                            >
                              <CloseIcon />
                            </IconButton>

                            <Grid
                              container
                              alignItems="center"
                              spacing={gridSpacing}
                              style={{ width: "100%", height: "100%" }}
                            >
                              {/* Rest of the content */}
                              <Grid
                                item
                                xs={12}
                                sm={6}
                                md={6}
                                style={{ textAlign: "center" }}
                              >
                                {file.type.startsWith("image/") ? (
                                  <Box
                                    component="img"
                                    sx={{
                                      maxWidth: "100%",
                                      maxHeight: "100px",
                                      display: "block",
                                      margin: "0 auto",
                                    }}
                                    onLoad={() => {
                                      URL.revokeObjectURL(
                                        imagePreviews.find(
                                          (preview) => preview.file === file
                                        )?.previewUrl
                                      );
                                    }}
                                    alt="just paste it images"
                                    src={
                                      imagePreviews.find(
                                        (preview) => preview.file === file
                                      )?.previewUrl
                                    }
                                  />
                                ) : (
                                  <AttachmentIcon
                                    sx={{
                                      fontSize: "48px",
                                      color: "#757575",
                                      display: "block",
                                      margin: "0 auto",
                                    }}
                                  />
                                )}
                              </Grid>
                              <Grid item xs={12} sm={6} md={6}>
                                <Typography
                                  variant="body2"
                                  align="center"
                                  style={{
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                    overflow: "hidden",
                                    maxWidth: "100%",
                                  }}
                                >
                                  {file.name}
                                </Typography>
                              </Grid>
                            </Grid>
                          </div>
                          <Divider sx={{ my: gridSpacing }} />
                        </Grid>
                      ))}
                    </Grid>
                  )}
                </Grid>
                
                <Grid item xs={6} sm={6} md={6} lg={6}>
                  <Box sx={{ mt: 1 }}>
                    <Button
                      disableElevation
                      fullWidth
                      size={isMobile ? "small" : "large"}
                      type="submit"
                      variant="contained"
                      color="secondary"
                      onClick={toggleFileUploadModel}
                    >
                      Upload File
                    </Button>
                  </Box>
                </Grid>
                <Grid item xs={6} sm={6} md={6} lg={6}>
                  <Box sx={{ mt: 1 }}>
                    <Button
                      disableElevation
                      fullWidth
                      size={isMobile ? "small" : "large"}
                      type="submit"
                      variant="contained"
                      color="secondary"
                      onClick={handlePostText}
                    >
                      Publish
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </MainCard>
      )}

      <Dialog open={whatsNewOpen} onClose={() => setWhatsNewOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <AutoAwesomeIcon color="secondary" />
          <Typography variant="h4" component="span" fontWeight="bold">What's New in Just Paste It</Typography>
        </DialogTitle>
        <DialogContent dividers sx={{ pb: 1 }}>
          <List>
            <ListItem alignItems="flex-start" sx={{ px: 0 }}>
              <ListItemIcon sx={{ minWidth: '36px', mt: '4px' }}>
                <NewReleasesIcon color="secondary" />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="subtitle1" fontWeight="bold" sx={{ color: 'text.primary' }}>No More CAPTCHAs for Temp Notes</Typography>}
                secondary="Creating and retrieving your private text notes is now friction-free! We have disabled CAPTCHA verification for these steps, making it much faster to write and load notes."
              />
            </ListItem>
            <ListItem alignItems="flex-start" sx={{ px: 0 }}>
              <ListItemIcon sx={{ minWidth: '36px', mt: '4px' }}>
                <NewReleasesIcon color="secondary" />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="subtitle1" fontWeight="bold" sx={{ color: 'text.primary' }}>Auto-Generated Secured Codes</Typography>}
                secondary="Don't waste time thinking of a retrieval code. If you leave the code field blank when publishing, we will automatically generate a secure 6-character room code for you."
              />
            </ListItem>
            <ListItem alignItems="flex-start" sx={{ px: 0 }}>
              <ListItemIcon sx={{ minWidth: '36px', mt: '4px' }}>
                <NewReleasesIcon color="secondary" />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="subtitle1" fontWeight="bold" sx={{ color: 'text.primary' }}>One-Click Copy to Clipboard</Typography>}
                secondary="You can now copy your secured room code instantly using the new copy button next to the code box in the sidebar."
              />
            </ListItem>
            <ListItem alignItems="flex-start" sx={{ px: 0 }}>
              <ListItemIcon sx={{ minWidth: '36px', mt: '4px' }}>
                <NewReleasesIcon color="secondary" />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="subtitle1" fontWeight="bold" sx={{ color: 'text.primary' }}>🔥 One-Time Read Notes</Typography>}
                secondary="Share a note that self-destructs after the first person reads it. Enable 'One-Time Read' when publishing — the note is permanently deleted from our servers the moment it is retrieved, leaving no trace."
              />
            </ListItem>
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setWhatsNewOpen(false)} color="secondary" variant="contained">
            Got it!
          </Button>
        </DialogActions>
      </Dialog>

      {/* Mobile Bottom Navigation — visible only on xs screens */}
      <Box
        sx={{
          display: { xs: 'flex', sm: 'none' },
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1300,
          borderTop: '1px solid',
          borderColor: 'divider',
          bgcolor: 'background.paper',
          boxShadow: '0 -2px 12px rgba(0,0,0,0.08)',
          pb: 'env(safe-area-inset-bottom)', // respects notch on iOS
        }}
      >
        <Button
          fullWidth
          variant="contained"
          color="secondary"
          startIcon={<EditNoteIcon />}
          onClick={handlePostText}
          sx={{ borderRadius: 0, py: 1.5, fontSize: '0.85rem', fontWeight: 700 }}
        >
          Publish Notes
        </Button>
        <Divider orientation="vertical" flexItem />
        <Button
          fullWidth
          variant="outlined"
          color="secondary"
          startIcon={<ArticleIcon />}
          onClick={toggleGetTextModel}
          sx={{ borderRadius: 0, py: 1.5, fontSize: '0.85rem', fontWeight: 700 }}
        >
          Retrieve Notes
        </Button>
      </Box>
    </>
  );
};

export default PasteText;
